import { useEffect, useMemo, useRef, useState } from 'react'

export const useIntersectionObserver = ({
  element,
  callback,
  cleanup,
  params
}: {
  element?: HTMLElement | null
  callback: (e: IntersectionObserverEntry, observer: IntersectionObserver) => void
  cleanup?: () => void
  params?: IntersectionObserverInit
}) => {
  const [observerRef, setObserverRef] = useState<HTMLElement | null>(element ?? null)
  const observer = useRef<IntersectionObserver>(null)

  useEffect(() => {
    if (element) {
      setObserverRef(element)
    }
  }, [element])

  useEffect(() => {
    if (observerRef) {
      observer.current = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.target === observerRef) {
            callback(e, observer.current!)
          }
        })
      }, params)

      observer.current.observe(observerRef)
    }

    return () => {
      observer.current?.disconnect()
      cleanup?.()
    }
  }, [observerRef, callback])

  return useMemo(
    () => ({
      setObserverRef
    }),
    [setObserverRef]
  )
}
